module.exports = __webpack_public_path__ + "static/media/megan-fox.0a84a9d0.jpg";